declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, SaveSingleEmbryoGradeInfoRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, ReadyForEmbroTransferRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, SaveIvfOocyteEmbryoStorageRequest, EmbryoGradesBetweenDateController, EmbryoGradesBetweenDateRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, ConvertEmbryoGradingToWellCultureRequest, EmbryosFromStoreController, EmbryosFromStoreRequest, SaveEmbryoStoreInfoRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbTcDetailsModal } from '../tcdetails.modal';
//import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { NgbEditGradingModal } from './editgrading.modal';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgbEditGradingDayModal } from './editgradingday.modal';
import { GradingPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { NgbEditGradingFetModal } from './editgradingfet.modal';
import { NgbEditGradingFetDetailModal } from './editgradingfetdetail.modal';
import { NgbEditGradingetModal } from './editgradinget.modal';

@Component({
  selector: 'ivfgradingedit',
  templateUrl: './ivfgradingedit.component.html',
  styleUrls: ['./ivfgradingedit.component.scss'],
  animations: [routerTransition()]
})

export class IvfGradingeditComponent implements OnInit, AfterViewInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  CurrentSaveSingleEmbryoGradeInfoRequest: SaveSingleEmbryoGradeInfoRequest;
  CurrentSaveIvfOocyteEmbryoStorageRequest: SaveIvfOocyteEmbryoStorageRequest;
  CurrentEditEmbryoStoreInfoRequest: SaveEmbryoStoreInfoRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;

  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
  @Input() DisplayName: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  searchTitle: string;
  public CanLoadReport: boolean = true;

  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;
  public PatientActorCode: number;
  public PatientCycleCode: number;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public ScanDetails: boolean = false;
  public Showoqa: boolean = true;
  public Showivf: boolean = false;
  TodayDate = new Date();
  public Day: number;
  public month: number;
  public Year: number;
  //

  CurrentReadyForEmbroTransferRequest: ReadyForEmbroTransferRequest;
  CurrentConvertEmbryoGradingToWellCultureRequest: ConvertEmbryoGradingToWellCultureRequest;
  CurrentFdActorReportsDocController: FdActorReportsDocController[];
  CurrentFDActorDocRequest: FDActorDocRequest;

  LoadForms() {
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFdActorReportsDocController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFdActorReportsDocController();
  }
  public SelectedReport: string;
  public SelectedActorCode: number = 92;
  GetFdActorReportsDocController() {
    this.StartRefreshing();

    this.CurrentFDActorDocRequest.ActorCode = 92;
    //this.CurrentFDActorDocRequest.ActorReportCode = null;
    //this.CurrentFDActorDocRequest.ActorReportTemplateCode = null;
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.DisplayName;
    this.CurrentFDActorDocRequest.ConditionalOperator = 11;
    //alert(this.FormattedCode);
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          // this.LoadPatients();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  //CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  //CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  //LoadPatients2() {
  //  this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();

  //  this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;

  //  this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;
  //  this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
  //  this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
  //      this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
  //  this.GetCycleOocyteQualityBetweenDateController();
  //}

  //GetCycleOocyteQualityBetweenDateController() {
  //  this.StartRefreshing();


  //  this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
  //        this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;

  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}
  CurrentEmbryoGradesBetweenDateController: EmbryoGradesBetweenDateController[];
  CurrentEmbryoGradesBetweenDateRequest: EmbryoGradesBetweenDateRequest;
  LoadPatients2() {
    this.CurrentEmbryoGradesBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();

    this.CurrentEmbryoGradesBetweenDateRequest.FacilityCode = AppData.Instance().SelectedBranchCode;

    this.CurrentEmbryoGradesBetweenDateRequest.ConditionalOperator = 10;
    this.CurrentEmbryoGradesBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentEmbryoGradesBetweenDateController;
    this.GetEmbryoGradesBetweenDateController();
  }

  GetEmbryoGradesBetweenDateController() {
    // this.StartRefreshing();

    this.CurrentEmbryoGradesBetweenDateRequest.FromDate = new Date();
    this.CurrentEmbryoGradesBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetEmbryoGradesBetweenDateController(this.CurrentEmbryoGradesBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentEmbryoGradesBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentEmbryoGradesBetweenDateController;

          // this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private router: Router,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal, private parserFormatter: NgbDateParserFormatter, private filter: GradingPipe) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {

    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    ///////////////////////
    this.LoadForms();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
    this.LoadPatients2();
    this.CurrentSaveSingleEmbryoGradeInfoRequest = new SaveSingleEmbryoGradeInfoRequest();
    this.CurrentSaveSingleEmbryoGradeInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest = new SaveIvfOocyteEmbryoStorageRequest();
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentReadyForEmbroTransferRequest = new ReadyForEmbroTransferRequest();
    this.CurrentReadyForEmbroTransferRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentConvertEmbryoGradingToWellCultureRequest = new ConvertEmbryoGradingToWellCultureRequest();
    this.CurrentConvertEmbryoGradingToWellCultureRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditEmbryoStoreInfoRequest = new SaveEmbryoStoreInfoRequest();
    this.CurrentEditEmbryoStoreInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.PatientActorCode = this.ActorCode;
    this.PatientCycleCode = this.CycleCode;


    this.onSetFeatureAccessConfig();

    this.CurrentActorProfileRequest = new ActorProfileRequest();
    this.CurrentActorProfileController = new ActorProfileController();
    if (this.NurseActorCode > 0) {
      this.CurrentActorProfileRequest.ActorCode = this.NurseActorCode;
    }
    else {
      this.CurrentActorProfileRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.CurrentActorProfileRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ValueChangeActorPersonalInfoController = new ActorPersonalInfoController();
    this.ValueChangeActorImageController = new ActorImageController();
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
  LoadClinics(reportCode: string) {

    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;

    r1.PatientReportCode = this.Code;
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
          this.FormData = this.ApiResData.Result;
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }


  onAssignedToActorCode(event: any) {

    if (event != null) {
      //alert(this.SelectedReport);
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      //this.CurrentFdActorReportsDocController[0].TemplateName = event;
      // console.log('event--_>' + event);
      //   }
      this.Code = this.SelectedReport;
      this.LoadClinics(this.Code);
    }

  }

  ngAfterViewInit() {
    // pSteps.loadStep();
  }

  onSetFeatureAccessConfig() {


    //Features
    var PersonalInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_PersonalInfo.toUpperCase())
    var ContactInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ContactInfo.toUpperCase())

    //
    var Feature_NurseProfile_ProfileSummary = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileSummary.toUpperCase())
    var Feature_NurseProfile_JobPreferences = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_JobPreferences.toUpperCase())

    var Feature_NurseProfile_Education = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Education.toUpperCase())

    var Feature_NurseProfile_EmploymentHistory = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_EmploymentHistory.toUpperCase())

    var Feature_NurseProfile_References = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_References.toUpperCase())

    var Feature_NurseProfile_Identities = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Identities.toUpperCase())
    var Feature_NurseProfile_Certifications = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Certifications.toUpperCase())

    var Feature_NurseProfile_MedicalFitness = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_MedicalFitness.toUpperCase())

    var Feature_NurseProfile_ProfileImage = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileImage.toUpperCase())

    var Feature_NurseProfile_Legalinfo = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Legalinfo.toUpperCase())


    //

    if (PersonalInfo_FeaturesList.length > 0) {
      if (PersonalInfo_FeaturesList[0].Edit === true) {
        this.CanEditProfileInfo = 1;
      }
      if (PersonalInfo_FeaturesList[0].List === true) {
        this.CanShowProfileInfo = 1;
        //this.GetActorPersonalDetailInfoController();
      }
    }
    if (ContactInfo_FeaturesList.length > 0) {
      if (ContactInfo_FeaturesList[0].Edit === true) {
        this.CanEditContactInfo = 1;
      }
      if (ContactInfo_FeaturesList[0].List === true) {
        this.CanShowContactInfo = 1;
      }
    }

    //
    if (Feature_NurseProfile_ProfileSummary.length > 0) {
      if (Feature_NurseProfile_ProfileSummary[0].Edit === true) {
        this.CanEditProfileSummary = 1;
      }
      if (Feature_NurseProfile_ProfileSummary[0].List === true) {
        this.CanShowProfileSummary = 1;
      }
    }

    if (Feature_NurseProfile_JobPreferences.length > 0) {
      if (Feature_NurseProfile_JobPreferences[0].Edit === true) {
        this.CanEditJobPreferences = 1;
      }
      if (Feature_NurseProfile_JobPreferences[0].List === true) {
        this.CanShowJobPreferences = 1;
      }
    }

    if (Feature_NurseProfile_Education.length > 0) {
      if (Feature_NurseProfile_Education[0].Edit === true) {
        this.CanEditEducation = 1;
      }
      if (Feature_NurseProfile_Education[0].List === true) {
        this.CanShowEducation = 1;
      }
    }

    if (Feature_NurseProfile_EmploymentHistory.length > 0) {
      if (Feature_NurseProfile_EmploymentHistory[0].Edit === true) {
        this.CanEditEmploymentHistory = 1;
      }
      if (Feature_NurseProfile_EmploymentHistory[0].List === true) {
        this.CanShowEmploymentHistory = 1;
      }
    }

    if (Feature_NurseProfile_References.length > 0) {
      if (Feature_NurseProfile_References[0].Edit === true) {
        this.CanEditReferences = 1;
      }
      if (Feature_NurseProfile_References[0].List === true) {
        this.CanShowReferences = 1;
      }
    }

    if (Feature_NurseProfile_Identities.length > 0) {
      if (Feature_NurseProfile_Identities[0].Edit === true) {
        this.CanEditIdentities = 1;
      }
      if (Feature_NurseProfile_Identities[0].List === true) {
        this.CanShowIdentities = 1;
      }
    }

    if (Feature_NurseProfile_Certifications.length > 0) {
      if (Feature_NurseProfile_Certifications[0].Edit === true) {
        this.CanEditCertifications = 1;
      }
      if (Feature_NurseProfile_Certifications[0].List === true) {
        this.CanShowCertifications = 1;
      }
    }

    if (Feature_NurseProfile_MedicalFitness.length > 0) {
      if (Feature_NurseProfile_MedicalFitness[0].Edit === true) {
        this.CanEditMedicalFitness = 1;
      }
      if (Feature_NurseProfile_MedicalFitness[0].List === true) {
        this.CanShowMedicalFitness = 1;
      }
    }

    if (Feature_NurseProfile_ProfileImage.length > 0) {
      if (Feature_NurseProfile_ProfileImage[0].Edit === true) {
        this.CanEditProfileImage = 1;
      }
      if (Feature_NurseProfile_ProfileImage[0].List === true) {
        this.CanShowProfileImage = 1;
      }
    }

    if (Feature_NurseProfile_Legalinfo.length > 0) {
      if (Feature_NurseProfile_Legalinfo[0].Edit === true) {
        this.CanEditLegalinfo = 1;
      }
      if (Feature_NurseProfile_Legalinfo[0].List === true) {
        this.CanShowLegalinfo = 1;
      }
    }
    this.IsSetAccessRights = true;





    //
  }

  //var PatientActorCode = this.ActorCode;


  //AddDetails() {
  //  const modalRef = this.modalService.open(NgbTcDetailsModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  //AddEventDetails() {
  //  const modalRef = this.modalService.open(NgbEventAddModal,
  //    {
  //      centered: true

  //    })

  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentEmbryoGradesBetweenDateController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentEmbryoGradesBetweenDateController,
          this.listFilter);
      }
    }
  }
  //

  //

  showPage(page: string) {
    this.currentPage = page;
  }
  BackToProfile() {
    alert("method");
    this.router.navigate(['testnurse/dashboard']);

  }
  BackToTreatment() {
    alert("Thistrearment");
    this.router.navigate(['testnurse/ivfdashboard']);
  }
  onClick() {
    let x = document.querySelector("#psa");
    if (x) {
      x.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  pickUp() {
    let y = document.querySelector("#pickup");
    if (y) {
      y.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  ET() {
    let z = document.querySelector("#et");
    if (z) {
      z.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  InsuminationLog() {
    let m = document.querySelector("#IL");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Grading() {
    let m = document.querySelector("#Grad");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  OQA() {
    let m = document.querySelector("#oqa");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  scans() {
    let m = document.querySelector("#scans");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  onpersonalInfoChange(event: any) {
    // console.log('onpersonalInfoChange');

    if (event != null) {

      this.ValueChangeActorPersonalInfoController = event;
      //console.log('this.ValueChangeActorPersonalInfoController.DisplayName--->' + this.ValueChangeActorPersonalInfoController.DisplayName);
      //this.ValueChangeActorPersonalInfoController.DisplayName = this.CurrentActorProfileController.DisplayName;
      if (this.ValueChangeActorPersonalInfoController.DisplayName != null) {
        this.CurrentActorProfileController.DisplayName = this.ValueChangeActorPersonalInfoController.DisplayName;
      }


    }

  }
  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorProfileController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  closeResult: string;
  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })

  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
  SelectedpatientDetails: EmbryoGradesBetweenDateController;

  Selectedpatient(objCategory: any) {
    var Patient: EmbryoGradesBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      this.ScanDetails = true;
      this.LoadCycles();

      this.LoadSingle();
      this.LoadOqaData();
      this.LoadFET();
      //this.LoadInsemination2();
      //this.LoadScansData();
      //this.LoadOvaryData();
      //this.LoadTestData();
      //this.LoadMedicineData();
    }

  }
  CurrentSingleWellCultureByCycleCodeController: SingleWellCultureByCycleCodeController[];
  CurrentSingleWellCultureByCycleCodeRequest: SingleWellCultureByCycleCodeRequest;
  LoadSingle() {

    this.CurrentSingleWellCultureByCycleCodeRequest = new SingleWellCultureByCycleCodeRequest();
    this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSingleWellCultureByCycleCodeRequest.ConditionalOperator = 10;
    this.CurrentSingleWellCultureByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetSingleWellCultureByCycleCodeController()
  }
  GetSingleWellCultureByCycleCodeController() {
    //this.StartRefreshing();


    this.actorservice.GetSingleWellCultureByCycleCodeController(this.CurrentSingleWellCultureByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSingleWellCultureByCycleCodeController = this.ApiResData.Result;

          ////var list = this.CurrentSingleWellCultureByCycleCodeController.filter(
          ////    function (a) {
          ////        return a.IsTransFerred == true
          ////    });

          ////this.CurrentSingleWellCultureByCycleCodeController = list;

          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          this.LoadActorCode();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfTreatmentPlanController: IvfTreatmentPlanController;
  PlanDetails: IvfTreatmentPlanController;
  CurrentIvfTreatmentPlanRequest: IvfTreatmentPlanRequest;
  LoadActorCode() {
    this.CurrentIvfTreatmentPlanRequest = new IvfTreatmentPlanRequest();
    this.CurrentIvfTreatmentPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentIvfTreatmentPlanRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfTreatmentPlanRequest.ConditionalOperator = 10;
    this.CurrentIvfTreatmentPlanRequest.ActorCode = 0;


    this.GetIvfTreatmentPlanController();
  }

  GetIvfTreatmentPlanController() {
    //this.StartRefreshing();
    //this.spinner.show();

    this.actorservice.GetIvfTreatmentPlanController(this.CurrentIvfTreatmentPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfTreatmentPlanController = this.ApiResData.Result;
          this.PlanDetails = this.CurrentIvfTreatmentPlanController[0];
          //this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
          //this.RefreshPatientsByDate();
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.spinner.hide();
          //this.stopRefreshing();
          //this.LoadActivities();
          this.LoadActorCodedetails();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  ActorCodeDetails: TreatmentCyclesByActorCodeController;
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadActorCodedetails() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    // this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          this.Day = new Date(this.ActorCodeDetails.DateOfInsemination).getDate();
          this.month = new Date(this.ActorCodeDetails.DateOfInsemination).getMonth();
          this.Year = new Date(this.ActorCodeDetails.DateOfInsemination).getFullYear();
          //this.SelectedActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          //this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadPlan();
          this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetActorCode(EggSourceType: string): number {
    // alert("new");
    if (EggSourceType == 'Donor') {
      var DonorActorCode = this.ActorCodeDetails.EggActorCode;
      return DonorActorCode;
    }
    else if (EggSourceType == 'Self') {
      var OwnerActorCode = this.ActorCodeDetails.OwnerActorCode;
      return OwnerActorCode;
    }
  }
  CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
  DSADetails: DSAActivityByCycleCodeController;
  CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

  LoadDSAData() {
    //alert("ScansData")
    this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDSAActivityByCycleCodeController();
  }

  GetDSAActivityByCycleCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
    this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
          this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
          //alert(this.DSADetails);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

          //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
          //var list = this.CurrentDSAActivityByCycleCodeController.filter(


          //    function (a) {
          //        var Date = this.FollicularScanEndInfo.ScanDate;
          //        var ActorCode = this.SelectedpatientDetails.ActorID;
          //        return a.ActivityDate == Date && a.ActorCode == ActorCode
          //    });

          //this.CurrentDSAActivityByCycleCodeController = list;
          //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
          //alert(this.Doc1);
          //alert(this.Antag);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentDSAActivityByCycleCodeController.filter(
      function (v, i, d) {

        return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
      }
    )

  }
  SelectedEmbryo(l: SingleWellCultureByCycleCodeController, doc: number) {


    this.CurrentSaveSingleEmbryoGradeInfoRequest.CellCount = this.GetCellCount(l, doc); //l.CellCount1;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.Grade = this.GetGrade(l, doc);// l.Grade1;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.DOC = doc;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.Imagecode = this.GetImage(l, doc);//.Image1;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.WellCulture = l.SingleWellCultureCode;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.Remarks = this.GetRemarks(l, doc);// l.Remarks1;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.DiscardedComments = l.DiscardedComments;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.IsDiscarded = l.isDisCarded;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.IsFreeze = l.IsFrozen;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.StrawNo = l.StrawNo;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.Location = l.Location;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.IsTransfer = l.IsTransferrable;
    //this.CurrentSaveSingleEmbryoGradeInfoRequest.Co
    const modalRef = this.modalService.open(NgbEditGradingModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'


      })
    modalRef.componentInstance.Wellno = l.WellNo;
    modalRef.componentInstance.DocumentUrl = this.GetImageUrl(l, doc);
    modalRef.componentInstance.Technique = l.Technique;
    modalRef.componentInstance.oqa = l.OoctyeQuality;
    modalRef.componentInstance.Day = doc;
    modalRef.componentInstance.ImageCodenew = this.GetImage(l, doc);
    modalRef.componentInstance.EmbryoGradeCode = this.GetEmbryoGradeCode(l, doc);

    modalRef.componentInstance.PatientName = this.SelectedpatientDetails.OwnerName;
    modalRef.componentInstance.Cyclenumber = this.SelectedpatientDetails.CycleNo;
    modalRef.componentInstance.ActorCode = this.PlanDetails.PatientActorCode;
    modalRef.componentInstance.CurrentSaveSingleEmbryoGradeInfoRequest = this.CurrentSaveSingleEmbryoGradeInfoRequest;

    modalRef.result.then(x => { this.GetSingleWellCultureByCycleCodeController() })
  }
  GradingCheck() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {

      this.IsGradingCompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  IsGradingCompleted() {


    console.log('..................');
    // this.StartRefreshing();
    //this.CurrentCompleteIvfCycleInseminationRequest.ConditionalOperator = 3;
    this.CurrentReadyForEmbroTransferRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentReadyForEmbroTransferRequest.EnterUserEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentReadyForEmbroTransferRequest.TDay = 1;
    this.CurrentReadyForEmbroTransferRequest.ConditionalOperator = 1;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.ReadyForEmbroTransfer(this.CurrentReadyForEmbroTransferRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
            //this.LoadMedicineData();

            this.stopRefreshing();
            this.LoadCycles();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  GradingCheckDrop() {
    // alert("Drop");
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.IsGradingCompletedDrop();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  IsGradingCompletedDrop() {


    console.log('..................');
    // this.StartRefreshing();
    //this.CurrentCompleteIvfCycleInseminationRequest.ConditionalOperator = 3;
    this.CurrentConvertEmbryoGradingToWellCultureRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentConvertEmbryoGradingToWellCultureRequest.ConditionalOperator = 10;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.ConvertEmbryoGradingToWellCulture(this.CurrentConvertEmbryoGradingToWellCultureRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
            //this.LoadMedicineData();

            this.stopRefreshing();
            this.LoadCycles();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  SemanAnalysis: TreatmentCycleStatusController[];
  SemanAnalysis2: TreatmentCycleStatusController;
  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
  LoadCycles() {
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetTreatmentCycleStatusController();
  }

  GetTreatmentCycleStatusController() {
    //this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.SemanAnalysis = this.ApiResData.Result;
          var Semanlist = this.SemanAnalysis.filter(
            function (a) {
              return a.PhaseActivity == "Embryo Grading";
            });
          this.SemanAnalysis = Semanlist;
          this.SemanAnalysis2 = this.SemanAnalysis[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //Selectedpatient() {
  //  this.ScanDetails = true;
  //}
  CurrentEmbryosFromStoreController: EmbryosFromStoreController[];

  CurrentEmbryosFromStoreRequest: EmbryosFromStoreRequest;
  LoadFET() {
    this.CurrentEmbryosFromStoreRequest = new EmbryosFromStoreRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentEmbryosFromStoreRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    this.CurrentEmbryosFromStoreRequest.DOC = "";
    this.CurrentEmbryosFromStoreRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentEmbryosFromStoreRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetEmbryosFromStoreController();
  }

  GetEmbryosFromStoreController() {
    //this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetEmbryosFromStoreController(this.CurrentEmbryosFromStoreRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentEmbryosFromStoreController = this.ApiResData.Result;

          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetMaxDOC(l: SingleWellCultureByCycleCodeController): number {
    if (l.DOC1 != null) {
      return l.DOC1
    }
    else if (l.DOC2 != null) {
      return l.DOC2
    }
    else if (l.DOC3 != null) {
      return l.DOC3
    }
    else if (l.DOC4 != null) {
      return l.DOC4
    }
    else if (l.DOC5 != null) {
      return l.DOC5
    }
    else if (l.DOC6 != null) {
      return l.DOC6
    }
    return 0;

  }


  CheckAddGrade(grade: string, discarded: boolean, frozen: boolean, transferrable: boolean, doc: number, maxdoc: number): boolean {

    if (grade == null && !discarded && !frozen && !transferrable) {
      return true
    }
    else if (grade == null && (discarded || frozen || transferrable)) {
      if (doc < maxdoc)
        return true
      else
        return false;
    }
    else
      if (grade != null)
        return false;

    return true;
  }

  CanAddGrade(l: SingleWellCultureByCycleCodeController, gradeNo: number): boolean {
    //this.IsGradingCompleted

    var maxdoc = this.GetMaxDOC(l);

    switch (gradeNo) {

      case 1:
        return this.CheckAddGrade(l.Grade1, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC1, maxdoc);

      case 2:
        return this.CheckAddGrade(l.Grade2, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC2, maxdoc);

      case 3:
        return this.CheckAddGrade(l.Grade3, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC3, maxdoc);

      case 4:
        return this.CheckAddGrade(l.Grade4, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC4, maxdoc);
      case 5:
        return this.CheckAddGrade(l.Grade5, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC5, maxdoc);
      case 6:
        return this.CheckAddGrade(l.Grade6, l.isDisCarded, l.IsFrozen, l.IsTransferrable, l.DOC6, maxdoc);
      default:
        return false;
    }

  }
  GetCellCount(l: SingleWellCultureByCycleCodeController, doc: number): number {
    //this.IsGradingCompleted

    //var maxdoc = this.GetMaxDOC(l);

    switch (doc) {

      case 1:
        return l.CellCount1;

      case 2:
        return l.CellCount2;

      case 3:
        return l.CellCount3;

      case 4:
        return l.CellCount4;
      case 5:
        return l.CellCount5;
      case 6:
        return l.CellCount6;
      default:
        return 0;
    }

  }
  GetGrade(l: SingleWellCultureByCycleCodeController, doc: number): string {
    //this.IsGradingCompleted

    //var maxdoc = this.GetMaxDOC(l);

    switch (doc) {

      case 1:
        return l.Grade1;

      case 2:
        return l.Grade2;

      case 3:
        return l.Grade3;

      case 4:
        return l.Grade4;
      case 5:
        return l.Grade5;
      case 6:
        return l.Grade6;
      default:
        return null;
    }

  }
  GetImageUrl(l: SingleWellCultureByCycleCodeController, doc: number): string {
    //this.IsGradingCompleted

    //var maxdoc = this.GetMaxDOC(l);

    switch (doc) {

      case 1:
        return l.DocFriendlyName1;

      case 2:
        return l.DocFriendlyName2;

      case 3:
        return l.DocFriendlyName3;

      case 4:
        return l.DocFriendlyName4;
      case 5:
        return l.DocFriendlyName5;
      case 6:
        return l.DocFriendlyName6;
      default:
        return null;
    }

  }

  GetEmbryoGradeCode(l: SingleWellCultureByCycleCodeController, doc: number): number {
    //this.IsGradingCompleted

    //var maxdoc = this.GetMaxDOC(l);

    switch (doc) {

      case 1:
        return l.D1EmbryoGrade;

      case 2:
        return l.D2EmbryoGrade;

      case 3:
        return l.D3EmbryoGrade;

      case 4:
        return l.D4EmbryoGrade;
      case 5:
        return l.D5EmbryoGrade;
      case 6:
        return l.D6EmbryoGrade;
      default:
        return 0;
    }

  }
  GetImage(l: SingleWellCultureByCycleCodeController, doc: number): number {
    //this.IsGradingCompleted

    //var maxdoc = this.GetMaxDOC(l);

    switch (doc) {

      case 1:
        return l.Image1;

      case 2:
        return l.Image2;

      case 3:
        return l.Image3;

      case 4:
        return l.Image4;
      case 5:
        return l.Image5;
      case 6:
        return l.Image6;
      default:
        return 0;
    }

  }
  GetRemarks(l: SingleWellCultureByCycleCodeController, doc: number): string {
    //this.IsGradingCompleted

    //var maxdoc = this.GetMaxDOC(l);

    switch (doc) {

      case 1:
        return l.Remarks1;

      case 2:
        return l.Remarks2;

      case 3:
        return l.Remarks3;

      case 4:
        return l.Remarks4;
      case 5:
        return l.Remarks5;
      case 6:
        return l.Remarks6;
      default:
        return null;
    }

  }
  GetMaxGrade(l: SingleWellCultureByCycleCodeController): string {
    if (l.Grade6 != null) {
      return l.Grade6
    }
    else if (l.Grade5 != null) {
      return l.Grade5
    }
    else if (l.Grade4 != null) {
      return l.Grade4
    }
    else if (l.Grade3 != null) {
      return l.Grade3
    }
    else if (l.Grade2 != null) {
      return l.Grade2
    }
    else if (l.Grade1 != null) {
      return l.Grade1
    }
    return "";

  }
  SaveTransfered(l: SingleWellCultureByCycleCodeController) {

    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
    this.CurrentSaveSingleEmbryoGradeInfoRequest.ConditionalOperator = 20;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.IsTransFerred = true;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.CellCount = l.CellCount1;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.DiscardedComments = l.DiscardedComments;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.DOC = l.DOC1;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.Grade = l.Grade1;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.Imagecode = l.Image1;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.IsDiscarded = l.isDisCarded;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.IsFreeze = l.IsFrozen;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.IsTransfer = l.IsTransFerred;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.Location = l.Location;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.Remarks = l.Remarks1;
    this.CurrentSaveSingleEmbryoGradeInfoRequest.WellCulture = l.SingleWellCultureCode
    //this.CurrentSaveSingleEmbryoGradeInfoRequest.Imagecode = this.ValueChangeActorImageController.ActorImageCode;
    this.actorservice.SaveSingleEmbryoGradeInfo(this.CurrentSaveSingleEmbryoGradeInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            ///this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            //this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            //this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            // this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );
  }
  CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
  CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;

  LoadOqaData() {
    //alert("ScansData")
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfOocyteEmbryoStorageByCodeController();
  }

  GetIvfOocyteEmbryoStorageByCodeController() {
    // this.StartRefreshing();

    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;

    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 20;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;

          if (this.CurrentIvfOocyteEmbryoStorageByCodeController != null ||
            this.CurrentIvfOocyteEmbryoStorageByCodeController.length > 0) {

            this.EmbryoStoreItems = new Array<EmbryoStoreItem>();
            this.CurrentIvfOocyteEmbryoStorageByCodeController.forEach((v, i, d) => {
              var item = new EmbryoStoreItem();
              item.IsSelected = false;
              //item.Morphology = v.Morphology;
              item.Grade = v.Grade;
              item.OocyteEmbryoStorageCode = v.OocyteEmbryoStorageCode;
              item.Status = v.Status;
              //item.Morphology = "";
              item.StorageUnitType = v.StorageUnitType;
              item.StorageUnitDetails = v.StorageUnitDetails;
              item.WellNo = v.WellNo;
              this.EmbryoStoreItems.push(item);
            });

          }

          //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
          //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

          //data.forEach((v, i, a) => {
          //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
          //});
          //for (let index = 0; index < data.length; index++){
          //    //alert(data[index].SingleWellFollicleCoder);

          //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
          //}
          //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //   alert(this.FollicularOocyteInfo.TreatmentCycle);
          //if (this.FollicularScanEndInfo.ScanDate != null) {
          //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.ScanDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  EmbryoStoreItems: Array<EmbryoStoreItem>;
  Store() {

    var toFreeze = this.CurrentSingleWellCultureByCycleCodeController.filter(function (v, i, d) {
      return v.IsFrozen == true
    });

    if (this.CurrentIvfOocyteEmbryoStorageByCodeController == null ||
      this.CurrentIvfOocyteEmbryoStorageByCodeController.length == 0) {

      this.EmbryoStoreItems = new Array<EmbryoStoreItem>();
      toFreeze.forEach((v, i, d) => {
        var item = new EmbryoStoreItem();
        item.IsSelected = false;
        item.Grade = this.GetMaxGrade(v);
        item.OocyteEmbryoStorageCode = 0;
        item.WellNo = v.WellNo;
        //item.Morphology = "";
        this.EmbryoStoreItems.push(item);
      });

    }
  }


  onSubmit2(data2: EmbryoStoreItem) {


    if (data2.OocyteEmbryoStorageCode == 0) {
      this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 10;
    }
    else {
      this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 20;
    }
    //  this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.ItemType = "EMBRYO";
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.LastUpdateDate = new Date();
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.LastUpdateTime = new Date();
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.Morphology = "";
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.OocyteEmbryoStorageCode = data2.OocyteEmbryoStorageCode;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.Status = "FROZEN";
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.StorageUnitDetails = data2.StorageUnitDetails;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.StorageUnitType = data2.StorageUnitType;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.Grade = data2.Grade;

    this.CurrentSaveIvfOocyteEmbryoStorageRequest.WellNo = data2.WellNo;


    this.actorservice.SaveIvfOocyteEmbryoStorage(this.CurrentSaveIvfOocyteEmbryoStorageRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            //this.LoadInsemination();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  dataChanged(newobj) {

    this._GetEmbryoGradesBetweenDateController();
  }
  _GetEmbryoGradesBetweenDateController() {
    this.StartRefreshing();

    this.CurrentEmbryoGradesBetweenDateRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentEmbryoGradesBetweenDateRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));

    this.actorservice.GetEmbryoGradesBetweenDateController(this.CurrentEmbryoGradesBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentEmbryoGradesBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentEmbryoGradesBetweenDateController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetEmbryoGradesBetweenDateController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetEmbryoGradesBetweenDateController();
    //ind++;
  }
  Editday() {
    const modalRef = this.modalService.open(NgbEditGradingDayModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
  }
  Fetgrading() {
    const modalRef = this.modalService.open(NgbEditGradingetModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false

      })
    // modalRef.componentInstance.Cyclenumber = this.SelectedpatientDetails.TreatmentCycleCode;
    // modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    //modalRef.componentInstance.model = "Add";
    modalRef.componentInstance.Cyclenumber = this.SelectedpatientDetails.TreatmentCycleCode;

    modalRef.componentInstance.ActorCode = this.ActorCodeDetails.RecepientActorCode;
    modalRef.componentInstance.EggSourceType = this.ActorCodeDetails.EggSourceType;
    modalRef.componentInstance.EggActorCode = this.ActorCodeDetails.EggActorCode;
    modalRef.result.then(x => { this.GetEmbryosFromStoreController() })
  }
  Editfetgrading(l: EmbryosFromStoreController) {
    this.CurrentEditEmbryoStoreInfoRequest.ActorCode = l.ActorCode;
    this.CurrentEditEmbryoStoreInfoRequest.CellStage = l.CellStage;
    this.CurrentEditEmbryoStoreInfoRequest.Count = l.Count;
    this.CurrentEditEmbryoStoreInfoRequest.CreatedUser = AppData.Instance().SelectedBranchCode;;
    this.CurrentEditEmbryoStoreInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentEditEmbryoStoreInfoRequest.CycleCode = l.TreatmentCycle;
    this.CurrentEditEmbryoStoreInfoRequest.Date = l.Date;
    this.CurrentEditEmbryoStoreInfoRequest.DOC = l.DOC;
    this.CurrentEditEmbryoStoreInfoRequest.FetDropletGradingCode = l.FETDropletGradingCode;
    this.CurrentEditEmbryoStoreInfoRequest.Grade = l.Grade;
    this.CurrentEditEmbryoStoreInfoRequest.ReGrade = l.Regrade;
    this.CurrentEditEmbryoStoreInfoRequest.ReGrade2 = l.Regrade2;
    this.CurrentEditEmbryoStoreInfoRequest.Remarks = l.Remarks;


    const modalRef = this.modalService.open(NgbEditGradingFetDetailModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false

      })
    //modalRef.componentInstance.Cyclenumber = this.SelectedpatientDetails.TreatmentCycleCode;
    modalRef.componentInstance.Date = l.Date;
    modalRef.componentInstance.DOC = l.DOC;
    modalRef.componentInstance.Embryocount = l.Count;
    modalRef.componentInstance.Grade1 = l.Grade;
    modalRef.componentInstance.Grade2 = l.Grade;
    modalRef.componentInstance.Cyclenumber = l.TreatmentCycle;
    modalRef.componentInstance.CurrentEditEmbryoStoreInfoRequest = this.CurrentEditEmbryoStoreInfoRequest;
    modalRef.result.then(x => { this.GetEmbryosFromStoreController() })
  }

  BackTodashboard() {
    //this.Showivf = true;
    //this.Showoqa = false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  printgrading() {
    this.printService.printDocument("embryograding",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, ActorCodedata: this.SelectedpatientDetails.EggSourceActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
      }
    );
  }
  printgradingdroplet() {
    this.printService.printDocument2(this.SelectedpatientDetails.OwnerFormattedCode, 0

    );
    this.printService.printDocument("embryogradingdroplet",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        EggSourceData: this.ActorCodeDetails.EggSourceType, DonorData: this.ActorCodeDetails.EggName, DonorCode: this.ActorCodeDetails.EggFormattedCode, TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, ActorCodedata: this.SelectedpatientDetails.EggSourceActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
      }
    );
  }
  printfet() {
    this.printService.printDocument2(this.SelectedpatientDetails.OwnerFormattedCode, 0

    );
    this.printService.printDocument("fet",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        EggSourceData: this.ActorCodeDetails.EggSourceType, DonorData: this.ActorCodeDetails.EggName, DonorCode: this.ActorCodeDetails.EggFormattedCode, TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, ActorCodedata: this.SelectedpatientDetails.EggSourceActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate /*TotalOocytes: this.SelectedpatientDetails.TotalOocytes*/
      }
    );
  }
}
export class EmbryoStoreItem {

  public OocyteEmbryoStorageCode: number;

  public WellNo: number;
  public StorageUnitType: string;
  public StorageUnitDetails: string;
  public Status: string;

  public Grade: string;
  //public Morphology: string;
  public IsSelected: boolean;
}
